$(document).ready(function() {


  window.addEventListener('scroll', function() {
    var section = document.querySelector('.block-event-theme');
    var windowHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var windowTop = window.pageYOffset || document.documentElement.scrollTop;
    var windowBottom = windowTop + windowHeight;
    var sectionTop = section.offsetTop;
    var sectionBottom = sectionTop + section.offsetHeight;

    // セクションの上端を超えた場合に is-top クラスを追加する
    if (windowTop > sectionTop) {
        section.classList.add('is-top');
    } else {
        section.classList.remove('is-top');
    }

    // セクションの下端を超えた場合に is-bottom クラスを追加する
    if (windowBottom > sectionBottom) {
        section.classList.add('is-bottom');
    } else {
        section.classList.remove('is-bottom');
    }
});

  // smooth scroll
  $('a[href^="#"]').click(function () {
    const speed = 600;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  // $(window).on('load scroll', handleScroll);

  // button fixed
  window.addEventListener('scroll', function() {
    var fixedElement = document.getElementById('js-button_footer');
    var footer = document.querySelector('footer');
    var fixedElementRect = fixedElement.getBoundingClientRect();
    var footerRect = footer.getBoundingClientRect();
  
    // footerが画面内に入ったらis-hideクラスを追加する
    if (fixedElementRect.bottom >= footerRect.top) {
      fixedElement.classList.add('is-hide');
    } else {
      fixedElement.classList.remove('is-hide');
    }
  });

  // ========================================
  // 時間指定ボタン・リンク表示制御（js-button-release / js-form-release）
  // ========================================
  // (function() {
  //   const releaseDate = new Date(2026, 8, 1, 10, 0, 0); // 2026年9月1日 10:00 (月は0始まりのため8を指定)
  //   const buttons = document.querySelectorAll('.js-button-release');
  //   const formLinks = document.querySelectorAll('.js-form-release');

  //   // 初期状態：ボタンを非表示にする
  //   buttons.forEach(function(btn) {
  //     btn.style.display = 'none';
  //   });

  //   // 初期状態：リンクを無効化＆下線を非表示にする
  //   formLinks.forEach(function(link) {
  //     link.dataset.originalHref = link.getAttribute('href');
  //     link.setAttribute('href', 'javascript:void(0)');
  //     link.style.textDecoration = 'none';
  //     link.style.pointerEvents = 'none';
  //   });

  //   function checkRelease() {
  //     const now = new Date();
  //     if (now >= releaseDate) {
  //       // ボタンを表示
  //       buttons.forEach(function(btn) {
  //         btn.style.display = '';
  //       });
  //       // リンクを有効化＆下線を復元
  //       formLinks.forEach(function(link) {
  //         link.setAttribute('href', link.dataset.originalHref);
  //         link.style.textDecoration = '';
  //         link.style.pointerEvents = '';
  //       });
  //     } else {
  //       // まだ時間前なら1分ごとに再チェック
  //       setTimeout(checkRelease, 60000);
  //     }
  //   }
  //   checkRelease();
  // })();

});
